import PageDefault from "../components/PageDefault";
import Link from "next/link";
import Image from "next/image";
import React from "react";
import DottedBg from "../components/pageUI/DottedBg";
import ContentPlacer from "../components/ContentPlacer";

export default function About() {
  return (
    <>
      <PageDefault pageTitle="About | SummerEyes" setBackground="bg-gray-50">
        <DottedBg />
        <div className="overflow-hidden bg-gray-50 pt-16 lg:pt-12">
          <div className="relative mx-auto lg:max-w-7xl">
            <svg
              className="absolute left-full hidden -translate-x-1/2 -translate-y-1/4 transform lg:block"
              width={404}
              height={784}
              fill="none"
              viewBox="0 0 404 784"
              aria-hidden="true"
            >
              <defs>
                <pattern
                  id="b1e6e422-73f8-40a6-b5d9-c8586e37e0e7"
                  x={0}
                  y={0}
                  width={20}
                  height={20}
                  patternUnits="userSpaceOnUse"
                >
                  <rect
                    x={0}
                    y={0}
                    width={4}
                    height={4}
                    className="text-gray-200"
                    fill="currentColor"
                  />
                </pattern>
              </defs>
              <rect
                width={404}
                height={784}
                fill="url(#b1e6e422-73f8-40a6-b5d9-c8586e37e0e7)"
              />
            </svg>
            <ContentPlacer>
              <div className="justify-left flex pb-12">
                <div className="justify-left relative md:w-3/4">
                  <h2 className="text-left text-3xl font-extrabold leading-8 tracking-tight text-gray-900 sm:text-5xl">
                    <span className="bg-gradient-to-tr from-summer-light-highlight to-summer-bright bg-clip-text text-transparent">
                      Delivering the AI-augmented future
                    </span>{" "}
                    we were promised.
                  </h2>
                  <p className="mt-4 max-w-3xl text-left text-xl text-gray-500">
                    SummerEyes is committed to building incredible software to
                    free up time from unnecessary work.
                  </p>
                </div>
              </div>

              <div className="relative mb-12 rounded-lg bg-white pr-8">
                <div className="lg:absolute lg:inset-0">
                  <div className="lg:absolute lg:inset-y-0 lg:left-0 lg:w-1/2">
                    <img
                      className="h-56 w-full rounded-tl-lg rounded-tr-lg rounded-br-none rounded-bl-none object-cover lg:absolute lg:h-full lg:rounded-tl-lg lg:rounded-tr-none lg:rounded-br-none lg:rounded-bl-lg"
                      src="/img/about_photo.png"
                      alt=""
                    />
                  </div>
                </div>
                <div className="relative w-full pt-12 pb-16 sm:pt-16 lg:mx-auto lg:grid lg:grid-cols-2 ">
                  <div className="pl-8 lg:col-start-2">
                    <div className="mx-auto max-w-prose text-base lg:ml-auto lg:mr-0 lg:max-w-lg">
                      <h2 className="font-semibold uppercase leading-6 tracking-wide text-summer-light-highlight-700">
                        What we do
                      </h2>
                      <h3 className="mt-2 text-3xl font-extrabold leading-8 tracking-tight text-gray-900 sm:text-4xl">
                        Our Mission
                      </h3>
                      <p className="mt-8 text-xl italic text-gray-500">
                        "To unlock human potential by reducing information
                        overload"
                      </p>
                      <div className="prose prose-indigo mt-5 text-gray-500">
                        <p>
                          At SummerEyes, we think that human-AI augmentation is
                          still in its infancy. We believe that it's time to
                          start delivering meaningful improvements to everyday
                          human life through AI use cases.
                        </p>
                        <p>
                          The improvement we think the world needs the most?
                          Reducing information overload to let people know more,
                          with less.
                        </p>
                        <p>
                          The web has resulted in the limit of our ability to
                          know more being constrained by our processing power
                          (i.e., how much we can read in a day), not by the
                          amount of info we have access to. We aim to increase
                          this limit through any means necessary - unlocking
                          potential to spend time on tasks humans are better
                          suited at doing.
                        </p>
                        <hr />
                        <h2 className="text-base font-semibold uppercase leading-6 tracking-wide text-summer-light-highlight-700">
                          Who we are
                        </h2>
                        <h3 className="mt-2 text-3xl font-extrabold leading-8 tracking-tight text-gray-900 sm:text-4xl">
                          Our Story
                        </h3>
                        <p>
                          Development on SummerEyes began in late 2021 when Zack
                          Zornitta (Founder) was working as a strategy
                          consultant. Part of his day-to-day included
                          significant time spent reading research reports &
                          whitepapers.
                        </p>
                        <p>
                          Aware of the latest developments in NLP (such as GPT,
                          BERT and other transformer architectures), and looking
                          to keep his coding skills fresh, he put together a
                          language model that could take in a report & generate
                          high-quality summaries.
                        </p>
                        <p>
                          After using it for a few weeks, friends & colleagues
                          noticed and wanted to install the tool locally, and
                          the goal of creating an excellent, user-friendly, and
                          accessible product experience has been the story
                          since.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </ContentPlacer>
          </div>
        </div>
      </PageDefault>
    </>
  );
}
